import { useEffect, useState } from 'react'
import { ModalAlert } from '@kenect-ut/kenect-ui-kit'
import PropTypes from 'prop-types'

export function CurrentUserError({ onRetry, onSignOut }) {
  const [open, setOpen] = useState(false)
  // KUI resolves the portal parent on mount; open on the following render.
  useEffect(() => setOpen(true), [])
  return (
    <ModalAlert
      id="current-user-error"
      parentSelector="#root"
      isOpen={open}
      color="red"
      title="Unable to load your account"
      message="Please try again or sign out."
      primaryButtonLabel="Retry"
      onPrimaryButtonClicked={onRetry}
      closeButtonLabel="Sign out"
      onCloseButtonClicked={onSignOut}
    />
  )
}

CurrentUserError.propTypes = {
  onRetry: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
}
